var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import { black, white } from '../../colors';
import { StyledLanguageSwitcherIcon, MobileLanguageSwitcherLink } from './LanguageSwitcher.styles';
import { WidgetWrapper } from '../Header.styles';

var LanguageSwitcher = function LanguageSwitcher(_a) {
  var _b = _a.isIconShown,
      isIconShown = _b === void 0 ? true : _b,
      _c = _a.isTextLight,
      isTextLight = _c === void 0 ? false : _c,
      _d = _a.isFullText,
      isFullText = _d === void 0 ? false : _d,
      translationLinks = _a.translationLinks,
      linkComponent = _a.linkComponent,
      t = _a.t,
      locale = _a.locale;

  var renderText = function renderText(english, arabic) {
    return locale === 'ar' ? t(english) : t(arabic);
  };

  var LinkComponent = linkComponent;
  return translationLinks && translationLinks.length ? /*#__PURE__*/React.createElement(WidgetWrapper, {
    "data-test": 'language-switcher'
  }, /*#__PURE__*/React.createElement(MobileLanguageSwitcherLink, {
    tabIndex: 0,
    as: // eslint-disable-next-line max-len
    // eslint-disable-next-line max-len, @typescript-eslint/no-explicit-any
    function as(pr) {
      return /*#__PURE__*/React.createElement(LinkComponent, __assign({
        disableLocalization: true
      }, pr));
    },
    to: translationLinks[0].url,
    href: translationLinks[0].url,
    color: isTextLight ? white() : black(),
    "data-ga-text": 'Language Switcher'
  }, isIconShown ? /*#__PURE__*/React.createElement(StyledLanguageSwitcherIcon, {
    role: 'img',
    "aria-label": 'globe'
  }) : null, isFullText ? renderText('english', 'arabic') : renderText('en', 'ar'))) : null;
};

export default LanguageSwitcher;